import { memo } from "react";
import { nFormatter } from "utils/parseNumber";
import EyeIcon from "components/icons/linear/eye.svg?react";
import PlayerPlayIcon from "components/icons/linear/player-play.svg?react";

import "./ViewButton.scss";

export enum ViewButtonType {
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
}

interface IViewButtonProps {
  count: number;
  type: ViewButtonType;
}

const viewIcons = {
  [ViewButtonType.IMAGE]: <EyeIcon />,
  [ViewButtonType.VIDEO]: <PlayerPlayIcon />,
};

export const ViewButton: React.FC<IViewButtonProps> = memo(({ count, type }) => {
  return (
    <div
      className="ViewButton"
      title={`${nFormatter(count)} views`}
      aria-label={`${nFormatter(count)} views`}
    >
      <span className="ViewButton-Icon">{viewIcons[type]}</span>
      <div className="ViewButton-Label">{nFormatter(count)}</div>
    </div>
  );
});
